import React from 'react'
import tw, { styled } from 'twin.macro'
import { Link } from 'gatsby'

import ArrowSVG from './arrow.inline.svg'

const QuickLinks = ({ items, title, ...props }) => (
    <Style className="quick-links" {...props}>
        {title ? <h2>{title}</h2> : null}

        <ul>
        { items.map((item, i) => item.path?.alias && (
            <li key={i}>
                {item.redirect_link ? (
                    <Link to={item.redirect_link.uri_alias}>
                        <ArrowSVG />{item.title}
                    </Link>
                ) : (
                    <Link to={item.path.alias}>
                        <ArrowSVG />{item.title}
                    </Link>
                )}
            </li>
        ))}
        </ul>
    </Style>
)


const Style = styled.div`
    > h2 {
        text-align: center;
        font-weight: 600;
        font-size: calc(1em + 1.75vmax);
        margin-bottom: 1em;
    }

    > ul {
        column-count: 1;
        column-gap: 5vmax;
        list-style: none;
        padding: 0;
        margin-left: auto;
        margin-right: auto;
        margin-bottom: 0;
        font-size: calc(1em + .2vmax);
        ${tw `columns-1`}

        ${({ compact }) => compact ? tw`md:columns-1` : tw`md:columns-2 xl:columns-3`}


        > li {
            display: inline-block;
            width: 100%;
            ${({ compact }) => compact ? tw`[marginBottom:.75em]` : tw`[marginBottom:1.5em]` }

            a {
                display: inline-flex;
                align-items: baseline;
                color: var(--textColor);
                outline: none;
                font-size: 80%;

                svg {
                    margin-right: .75em;
                    min-width: 1em;
                    ${tw `text-primary`}
                }

                &:focus svg {
                    ${tw `text-orange`}
                }

                @media (hover: hover) {
                    &:hover, &:active svg {
                        ${tw `text-primary`}
                    }
                }
            }
        }
    }
`

export default QuickLinks;